<template>
    <Popover class="relative">
        <PopoverButton
            v-if="loggedIn"
            class="group flex items-center justify-center rounded-full border-2 border-white p-2"
            @click="toggle(watchLater, type, id)"
            @mouseenter="openTip"
            @mouseleave="hideTipFromTrigger"
        >
            <AsyncIcon
                :name="watchLater.saved ? 'check' : 'plus'"
                :class="{ 'group-hover:hidden': watchLater.saved }"
                class="h-5 w-5 text-white"
            />

            <AsyncIcon
                v-if="watchLater.saved"
                name="xmark"
                class="hidden h-5 w-5 text-white group-hover:block"
            />
        </PopoverButton>

        <Transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0 translate-y-1"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 translate-y-1"
        >
            <div v-if="showTip">
                <PopoverPanel
                    class="absolute bottom-16 left-1/2 z-10 mt-3 w-screen max-w-lg -translate-x-1/2 transform px-2 sm:px-0"
                    static
                    @mouseenter="mouseOverTip = true"
                    @mouseleave="hideTip"
                >
                    <div
                        class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5"
                    >
                        <div class="relative grid gap-6 bg-white px-5 py-6 sm:p-8">
                            <div class="text-lg font-medium">
                                {{
                                    trans(
                                        'Save this show or any resources below to help you organise your lesson plans.',
                                    )
                                }}
                            </div>

                            <ul role="list" class="mx-5 list-disc">
                                <li>
                                    {{
                                        trans(
                                            'All Live It shows and resources will display this icon and can be saved',
                                        )
                                    }}
                                </li>

                                <li>
                                    {{
                                        trans(
                                            'Live It will automatically organize all your saved resources by program to save you time and effort',
                                        )
                                    }}
                                </li>
                            </ul>

                            <div class="ml-auto">
                                <Button variant="primary" tag="button" @click="saveTip">
                                    {{ trans('Got it, Thanks') }}
                                </Button>
                            </div>
                        </div>
                    </div>
                </PopoverPanel>
            </div>
        </Transition>
    </Popover>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import { useBookmarks } from '@/scripts/hooks/app/useBookmarks'
    import { useAuth } from '@/scripts/hooks/useAuth'
    import { useUserTips } from '@/scripts/hooks/useUserTips'
    import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
    import Button from '@/views/components/Button.vue'
    import AsyncIcon from '@/views/components/AsyncIcon.vue'
    defineProps({
        type: {
            type: String,
            required: true,
        },
        id: {
            type: Number,
            required: true,
        },
    })
    const { watchLater, toggle } = useBookmarks()
    const { loggedIn } = useAuth()
    const { showWatchLater, hide } = useUserTips()
    const showTip = ref(false)
    const mouseOverTip = ref(false)
    const openTip = () => showWatchLater.value && !watchLater.value.saved && (showTip.value = true)
    const hideTip = () => {
        mouseOverTip.value = false
        showTip.value = false
    }
    const hideTipFromTrigger = () =>
        setTimeout(() => mouseOverTip.value || (showTip.value = false), 200)
    const saveTip = () => {
        showTip.value = false

        hide('watch_later')
    }
</script>
